var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49741 2.49927H3.33209C2.872 2.49927 2.49902 2.87224 2.49902 3.33233V9.16379C2.49902 9.62387 2.872 9.99685 3.33209 9.99685H7.49741C7.9575 9.99685 8.33048 9.62387 8.33048 9.16379V3.33233C8.33048 2.87224 7.9575 2.49927 7.49741 2.49927Z",
    stroke: "#6B7280",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6615 2.49927H12.4962C12.0361 2.49927 11.6631 2.87224 11.6631 3.33233V5.83153C11.6631 6.29162 12.0361 6.66459 12.4962 6.66459H16.6615C17.1216 6.66459 17.4945 6.29162 17.4945 5.83153V3.33233C17.4945 2.87224 17.1216 2.49927 16.6615 2.49927Z",
    stroke: "#6B7280",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6615 9.99683H12.4962C12.0361 9.99683 11.6631 10.3698 11.6631 10.8299V16.6613C11.6631 17.1214 12.0361 17.4944 12.4962 17.4944H16.6615C17.1216 17.4944 17.4945 17.1214 17.4945 16.6613V10.8299C17.4945 10.3698 17.1216 9.99683 16.6615 9.99683Z",
    stroke: "#6B7280",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49741 13.3291H3.33209C2.872 13.3291 2.49902 13.7021 2.49902 14.1622V16.6614C2.49902 17.1214 2.872 17.4944 3.33209 17.4944H7.49741C7.9575 17.4944 8.33048 17.1214 8.33048 16.6614V14.1622C8.33048 13.7021 7.9575 13.3291 7.49741 13.3291Z",
    stroke: "#6B7280",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon01);
export default __webpack_public_path__ + "static/media/icon01.183ff64cd8ce367f38e5f1e80b1a9b57.svg";
export { ForwardRef as ReactComponent };